import { getEditorInfo } from "src/common/attrEdit";
import { AttrTypeName } from "src/types/AttrType";
import { ZUid } from "src/types/zUid";
import { ZAttribute } from "src/types/ZAttribute";
import { loadAttributeInfo, saveAttribute } from "../../objectsApi";

const changeMultipleBlockers = async (
  parentId: ZUid,
  blockerId: ZUid,
  remove?: boolean,
) => {
  const attr = await loadAttributeInfo(parentId);
  const editorInfo = getEditorInfo(attr.viewStyles);
  if (
    editorInfo?.component?.editor !== "ObectRefSelector" &&
    editorInfo?.component?.editor !== "ObjectRefTable"
  )
    return;
  const component = editorInfo?.component;
  const blockers = component.multipleBlockers ?? [];
  component.multipleBlockers = remove
    ? blockers?.filter((id) => id !== blockerId)
    : [...blockers, blockerId];
  const result: ZAttribute = {
    ...attr,
    viewStyles: JSON.stringify({ ...editorInfo, component }),
  };
  await saveAttribute(result);
};

const onObjectRefSave = async (oldAttr: ZAttribute, newAttr: ZAttribute) => {
  const oldId = oldAttr.parentAttributeId;
  const newId = newAttr.parentAttributeId;
  const blockerId = newAttr.id;
  if (oldId === newId) return;
  if (oldId) await changeMultipleBlockers(oldId, blockerId, true);
  if (newId) await changeMultipleBlockers(newId, blockerId);
};

export const onAttrSaveMap: Partial<
  Record<
    AttrTypeName,
    (oldAttr: ZAttribute, newAttr: ZAttribute) => Promise<void>
  >
> = {
  [AttrTypeName.object]: onObjectRefSave,
};
